export function getSqlDateTimeFromIsoString(
  isoString: string | null | undefined,
): string | null {
  if (!isoString) {
    return null
  }
  return isoString.slice(0, 19).replace('T', ' ')
}
